import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePhone } from "../api/deletePhone";

export const useDeletePhone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ endPoint, id, body }) => deletePhone(endPoint, id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allPhone"] });
    },
  });
};

